import $ from 'jquery'
import toastr from '../../utils/toastr'
import 'blueimp-file-upload-npm'

class Module {
  constructor ($module) {
    this.$container = $module.find('.js-attachments')
    this.$extra = $module.find('.js-extra')
    this.$uploadBtn = $module.find('.js-upload-btn')
    this.$uploader = $module.find('.js-uploader')
    this.uploadUrl = this.$container.data('upload-url')
    this.template = this.$container.data('prototype')
    
    this.bind()
  }
  
  bind () {
    const self = this
    
    this.$uploadBtn.click((e) => {
      e.preventDefault()
      self.$container.find('.js-uploader').click()
    })
    
    this.$uploader.fileupload({
      url: self.uploadUrl,
      dataType: 'json',
      add: (e, data) => {
        self.$container.addClass('refreshing')
        data.submit()
      },
      done: (e, res) => {
        self.appendUploadedFile(res.result)
      },
      stop: (e, data) => {
        this.$container.removeClass('refreshing')
      }
    })
    
    this.$container.on('click', '.js-delete-file', function (e) {
      e.preventDefault()
      $(this).closest('div').remove()
    })
  }
  
  appendUploadedFile (data) {
    if (data.error) {
      toastr.error(data.error)
      return
    }
    
    let el = this.template
    
    for (const i in data) {
      if (!Object.prototype.hasOwnProperty.call(data, i)) {
        continue
      }
      el = el.replace(new RegExp('__' + i + '__', 'gi'), data[i])
    }
    
    this.$extra.append(el)
    this.$uploadBtn.text(this.$uploadBtn.data('more-text'))
  }
}

$(function () {
  $('.js-ticket-view').each(function () {
    new Module($(this))
  })
})
